'use client'

import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import Cookies from 'js-cookie'
import { FC, useEffect, useState } from 'react'
import StoryblokClient, { ISbRichtext } from 'storyblok-js-client'
const Storyblok = new StoryblokClient({ accessToken: process.env.NEXT_PUBLIC_SB_PREVIEW_TOKEN })

import { PhnxButton } from '../Button/Button'
import styles from './Gatecontent.module.css'

interface GatecontentBlokProps {
  blok: {
    Ungate: boolean
    bttonText: string
    cookieAccessKey: string
    downloadLink: { url: string }
    flipsnackEmbed: string
    description: ISbRichtext
  } & SbBlokData
  isInsideStoryblok: any
}

const Gatecontent: FC<GatecontentBlokProps> = ({ blok, isInsideStoryblok }) => {
  const [contentVisible, setContentVisible] = useState(false)

  useEffect(() => {
    // if isInsideStoryblok is true ignore this
    if (isInsideStoryblok) {
      setContentVisible(true)
      return
    }
    if (blok.Ungate) {
      setContentVisible(true)
      return
    }

    const cookie = Cookies.get('form-cookie')

    if (
      cookie !== undefined &&
      (blok.cookieAccessKey === undefined ||
        blok.cookieAccessKey === '' ||
        blok.cookieAccessKey === cookie)
    ) {
      setContentVisible(true)
    } else {
      // go back to the home page
      window.location.href = '/'
    }
  }, [blok, isInsideStoryblok])

  return (
    <div {...storyblokEditable(blok)} id="gated-content" className={styles.gatedContent}>
      {contentVisible && (
        <div
          id="gated-content-body"
          className={`${styles.gatedContentBg} ${
            blok.description && Storyblok.richTextResolver.render(blok.description) !== '<p></p>'
              ? `${styles.gatedContentCopy} container`
              : ''
          }`}
        >
          {blok.description &&
            Storyblok.richTextResolver.render(blok.description) !== '<p></p>' && (
              <div
                className={`${styles.gatedContentCopyRich} text-left`}
                dangerouslySetInnerHTML={{
                  __html: Storyblok.richTextResolver.render(blok.description),
                }}
              />
            )}

          {blok.downloadLink?.url && blok.bttonText && (
            <div className={styles.btn}>
              <PhnxButton
                type="link"
                variant="primary"
                label={blok.bttonText}
                href={blok.downloadLink.url}
                openInNewWindow={true}
              />
            </div>
          )}
        </div>
      )}
      {contentVisible &&
        blok.flipsnackEmbed &&
        (Storyblok.richTextResolver.render(blok.description) === '<p></p>' ||
          Storyblok.richTextResolver.render(blok.description) === '') && (
          <div
            id="gated-content-container"
            className={styles.gatedContentContainer}
            dangerouslySetInnerHTML={{
              __html: blok.flipsnackEmbed,
            }}
          />
        )}
    </div>
  )
}

export default Gatecontent
